// 这个文件就是封装的路由模块

// 1.引入vue和vue-router
import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入路由所映射的组件
import Index from '@/pages/Index.vue'
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
// 挂载：让Vue使用VueRouter进行路由管理
Vue.use(VueRouter)
// 2.创建路由对象
var router = new VueRouter({
  routes: [
    {
      name: 'Index',
      // path: '/Index',
      path: '/',
      component: Index,
      meta: {
        keepAlive: true
      }
    }
  ]
})
// 暴露
export default router
